import APP_ASSETS from "@/assets";
import { DrawerClose, DrawerFooter } from "@/components/ui/drawer";
import { Order, OrderType } from "@/models";
import { useEffect, useState } from "react";
import { useToast } from "./ui/use-toast";
import { useMerchant } from "@/contexts";
import { LoadingSpinner } from ".";
import { ethers } from "ethers";
import { Skeleton } from "./ui/skeleton";
import { getMerchantUpi } from "@/helper/localstorage";
import { copyToClipboard, upiIdDisplay } from "@/lib/utils";

interface CompletedOrderDrawerProps {
  order: Order;
  onClose: () => void;
  isLoading: boolean;
}

const CompletedOrderDrawer = ({
  order,
  onClose,
  isLoading,
}: CompletedOrderDrawerProps) => {
  const [encUpiId, setEncUpiId] = useState<string | null>(null);
  const { toast } = useToast();
  const {
    merchantDetails,
    hasFetched: fetchedMerchantDetails,
    isLoading: fetchingMerchantDetails,
  } = useMerchant();

  useEffect(() => {
    (async () => {
      const upi = await getMerchantUpi();
      if (upi) {
        setEncUpiId(upi);
      }
    })();
  }, []);

  return (
    <>
      <section className="mx-4 flex flex-col justify-center gap-2">
        <div className="flex flex-col justify-center gap-1">
          <label
            style={{
              fontWeight: "900",
            }}
            className={`font-satoshiBold w-fit rounded bg-green-500 p-2 text-xs tracking-wide text-text-dark`}
            htmlFor="address">
            {order.orderType === OrderType.SELL ? "SENT" : "RECEIVED"}
          </label>
          <p className="text-2xl font-bold text-text-light">
            ₹{" "}
            {Math.round(Number(ethers.utils.formatUnits(order.fiatAmount, 6)))
              .toFixed(2)
              .toString()}
          </p>
        </div>
        <div className="flex flex-col justify-center gap-1">
          {order?.encUpi && upiIdDisplay(order?.encUpi)?.tempQr ? null : (
            <label
              className="font-satoshiBold text-xs tracking-wide text-text-light"
              htmlFor="address">
              TO {order.orderType === OrderType.SELL ? "THIS" : "YOUR"} UPI ID
            </label>
          )}
          <div className="flex flex-wrap items-center justify-start gap-4 overflow-x-auto">
            {order?.encUpi && upiIdDisplay(order?.encUpi)?.tempQr ? (
              <p className="text-2xl font-bold text-text-light">
                {order.orderType === OrderType.BUY ? (
                  !fetchingMerchantDetails &&
                  fetchedMerchantDetails &&
                  merchantDetails ? (
                    encUpiId
                  ) : (
                    <LoadingSpinner className="text-text-primary" />
                  )
                ) : order?.encUpi ? (
                  upiIdDisplay(order?.encUpi)?.extractedUpi
                ) : (
                  <LoadingSpinner className="text-text-primary" />
                )}
              </p>
            ) : (
              <p className="text-2xl font-bold text-text-light">
                {order.orderType === OrderType.BUY ? (
                  !fetchingMerchantDetails &&
                  fetchedMerchantDetails &&
                  merchantDetails ? (
                    encUpiId
                  ) : (
                    <LoadingSpinner className="text-text-primary" />
                  )
                ) : order?.encUpi ? (
                  upiIdDisplay(order?.encUpi)?.extractedUpi
                ) : (
                  <LoadingSpinner className="text-text-primary" />
                )}
              </p>
            )}
            {order.orderType === OrderType.SELL &&
            order?.encUpi &&
            !upiIdDisplay(order?.encUpi)?.tempQr ? (
              <img
                className="color-black h-7 w-7 hover:cursor-pointer"
                src={APP_ASSETS.ICONS.PASTE}
                alt={APP_ASSETS.ICONS.PASTE_BLACK}
                onClick={() => {
                  if (order.encUpi) {
                    copyToClipboard(upiIdDisplay(order.encUpi)?.extractedUpi);
                    toast({
                      title: "Upi Copied",
                    });
                  }
                }}
              />
            ) : (
              <img
                className="color-black h-7 w-7 hover:cursor-pointer"
                src={APP_ASSETS.ICONS.PASTE}
                alt={APP_ASSETS.ICONS.PASTE_BLACK}
                onClick={() => {
                  if (order.encUpi) {
                    copyToClipboard(upiIdDisplay(order.encUpi)?.qrCode);
                    toast({
                      title: "Upi Copied",
                    });
                  }
                }}
              />
            )}
          </div>
        </div>
      </section>
      <DrawerFooter>
        {isLoading ? (
          <Skeleton className="h-[44px] w-full bg-bg-grey" />
        ) : (
          <div className="text-white">
            Order Completed, you can close this now.
          </div>
        )}
        <DrawerClose
          onClick={() => {
            onClose?.();
          }}>
          <div className="w-full rounded-md border-[1px] border-black bg-bg-secondary p-2 font-bold text-text-light">
            Close
          </div>
        </DrawerClose>
      </DrawerFooter>
    </>
  );
};

export default CompletedOrderDrawer;
